<template>
  <section id="yd-best-app" class="md:mb-16 mb-10">
    <div class="card rounded-24 lg:-mt-32 -mt-16 bg-grey-light3 lg:px-32 xl:pt-12 lg:pt-8 text-center pb-0">
      <h1 class="xl:text-4xl md:text-2xl text-xl font-bree-serif">
        {{ $t('bestClass.title') }}
      </h1>
      <p class="md:text-xl md:mx-10 lg:my-10 my-6">
        {{ $t('bestClass.subtitle') }}
      </p>
      <hr class="border-t-3 text-white sm:block hidden">
      <div class="mt-10 mb-6">
        <span v-for="(i,index) in 5" :key="i" class="inline-block text-base sm:text-xl bg-blue2 text-primary tracking-widest font-rubik-medium text-center rounded-25 py-1 px-3 mx-2 mb-2">
          {{ 2017 + index }}
        </span>
      </div>
      <h2 class="uppercase text-primary tracking-widest xl:text-2xl text-lg md:mb-12 mb-6">
        {{ $t('bestClass.bestInClass') }}
      </h2>
      <img v-lazy-load data-src="@/assets/img/img-yd-app.svg" alt="" class="md:block hidden">
      <img v-lazy-load data-src="@/assets/img/img-yd-app-small.svg" alt="" class="md:hidden mx-auto">
    </div>
  </section>
</template>

<script>
export default {
  name: 'CardGrey'
}
</script>

<style scoped>

</style>
